import { render, staticRenderFns } from "./FalhaReconhecimento.vue?vue&type=template&id=8af10b74&"
import script from "./FalhaReconhecimento.vue?vue&type=script&lang=js&"
export * from "./FalhaReconhecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports